module.exports = __webpack_public_path__ + "static/r10-51149f8d981a1bda3919996516bea8c7.jpg";